import React from "react";
import classnames from "classnames";
import './TabTitleStyles.css'

interface TabTitleProps {
    isTabSelected: boolean,
    title: string,
    darkMode?: boolean;
}

const TabTitle: React.FC<TabTitleProps> = ({isTabSelected, title, darkMode= false}) => {
    return (
        <span className={classnames('baseTabTitle', (isTabSelected ? 'openedTabTitleStyle' : 'closedTabTitleStyle'), {'darkColor': darkMode})}>
            {title}
        </span>
    );
};

export default TabTitle;
